// extracted by mini-css-extract-plugin
export var actionButton = "_qx-0";
export var actionMenuContainer = "_qx-i";
export var bubble = "_qx-2";
export var bubbleActionMenu = "_qx-j";
export var bubbleContext = "_qx-6";
export var bubbleItems = "_qx-7";
export var customer = "_qx-3";
export var divider = "_qx-8";
export var fileList = "_qx-9";
export var hiddenComment = "_qx-o";
export var infoAbove = "_qx-a";
export var internal = "_qx-4";
export var lightActionButton = "_qx-1";
export var link = "_qx-b";
export var merchant = "_qx-5";
export var message = "_qx-c";
export var profilePicture = "_qx-e";
export var quillToolbarContainer = "_qx-f";
export var senderDate = "_qx-g";
export var senderDateCustomer = "_qx-h";
export var senderName = "_qx-d";
export var time = "_qx-k";
export var uploadedImage = "_qx-l";
export var username = "_qx-m";
export var xsmall = "_qx-n";